/*
 *  Developed by CQ Inversiones SAS. Copyright (c) 2024. All rights reserved.
 *  Desarrollado por CQ Inversiones SAS. Copyright (c) 2024. Todos los derechos reservados.
 */

/*
 * Project:      mkad-frontend
 * Developed by: Juan David Pelaez
 * Date:         29/05/24 - 19:30:31
 * Module name:  request-context-token.const
 * File name:    request-context-token.const.ts
 * IDE:          WebStorm
 */

import {HttpContextToken} from '@angular/common/http';

export const AUTH_SHOULD_INTERCEPT = new HttpContextToken(() => true)
